var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.steps)?_c('div',{staticClass:"d-flex flex-row align-items-center justify-content-between wrapper"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:`step-${index}`,class:[step === _vm.activeStep ? 'dot dot__active' : 'dot']},[_vm._v(" "+_vm._s(step)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }